import { Box, FormControl, Text } from '@chakra-ui/react';
import type { ReactNode } from 'react';

/** Petit intitulé espacé (« VOTRE COMMANDE »). */
export function Eyebrow({ children, accent, className }: { children: ReactNode; accent?: boolean; className?: string }) {
  return <Text className={`cv2-eyebrow${accent ? ' cv2-eyebrow--accent' : ''}${className ? ` ${className}` : ''}`}>{children}</Text>;
}

/**
 * Carte blanche bordée regroupant une section du formulaire : numéro en
 * couleur de marque, titre en capitales, aide optionnelle.
 */
export function Section({ index, title, hint, children, className }: { index?: string; title: string; hint?: ReactNode; children: ReactNode; className?: string }) {
  return (
    <Box as="section" className={`cv2-section CheckoutV2Section${className ? ` ${className}` : ''}`}>
      <Box className="cv2-section-head">
        {index && <Text className="cv2-section-index">{index}</Text>}
        <Box>
          <Text as="h3" className="cv2-title">
            {title}
          </Text>
          {hint && (
            <Text className="cv2-hint" mt={1}>
              {hint}
            </Text>
          )}
        </Box>
      </Box>
      {children}
    </Box>
  );
}

/** Champ : label capitales espacées + contrôle + erreur. */
export function Field({ label, error, isRequired, children, flex, minW }: { label?: string; error?: string; isRequired?: boolean; children: ReactNode; flex?: number | string; minW?: string | number }) {
  return (
    <FormControl isRequired={isRequired} isInvalid={!!error} flex={flex} minW={minW}>
      {label && (
        <Text as="label" className="cv2-label">
          {label}
        </Text>
      )}
      {children}
      {error && <Text className="cv2-error">{error}</Text>}
    </FormControl>
  );
}
